// / --- smooth scroll --------------
 
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});
 
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});
 
gsap.ticker.lagSmoothing(0);
 
// --- smooth scroll --------------

// ====================== HEADER EFFECT ======================
document.addEventListener("click", function (e) {

  const hamburger = e.target.closest(".cust-header-hamburger");
  const menu = document.getElementById("mobileMenu");
  const header = document.querySelector(".header");

  if (!hamburger || !menu || !header) return;

  hamburger.classList.toggle("active");
  menu.classList.toggle("active");

  if (menu.classList.contains("active")) {

    // Menu open
    document.body.style.overflow = "hidden";

    // Mobile header background change
    header.classList.remove("bg-change-top");
    header.classList.add("bg-change");

  } else {

    // Menu close
    document.body.style.overflow = "";

    // Normal mobile scroll flow
    if (window.scrollY <= 5) {
      header.classList.add("bg-change-top");
      header.classList.remove("bg-change");
    } else {
      header.classList.add("bg-change");
      header.classList.remove("bg-change-top");
    }

  }
});


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  let lastScrollY = window.scrollY;

  const mq = window.matchMedia('(min-width: 950px)');
  const isHomePage = window.location.pathname === '/';

  const handleScroll = () => {
    const currentY = window.scrollY;

    if (mq.matches) {
      // ===== DESKTOP =====

      if (isHomePage) {
        header.classList.add('home-header');
      } else {
        header.classList.remove('home-header');
      }

      if (currentY <= 30) {
        header.classList.add('is-at-top');
        header.classList.remove('is-scrolled', 'is-scroll-up');
      } 
      else if (currentY > lastScrollY && currentY >= 31) {
        header.classList.add('is-scrolled');
        header.classList.remove('is-scroll-up', 'is-at-top');
      } 
      else if (currentY < lastScrollY) {
        header.classList.add('is-scroll-up');
        header.classList.remove('is-scrolled', 'is-at-top');
      }

      header.classList.remove('bg-change', 'bg-change-top');

    } else {
      // ===== MOBILE =====

      header.classList.remove('home-header');

      // Agar mobile menu open hai,
      // to scroll par bg-change-top wapas nahi lagana
      const menu = document.getElementById("mobileMenu");

      if (menu && menu.classList.contains("active")) {
        header.classList.add('bg-change');
        header.classList.remove('bg-change-top');
      } else {
        if (currentY <= 1) {
          header.classList.add('bg-change-top');
          header.classList.remove('bg-change');
        } else {
          header.classList.add('bg-change');
          header.classList.remove('bg-change-top');
        }
      }

      header.classList.remove(
        'is-scrolled',
        'is-scroll-up',
        'is-at-top'
      );
    }

    lastScrollY = currentY;
  };

  handleScroll();

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  mq.addEventListener('change', handleScroll);
});

document.addEventListener("click", function (e) {
  const header = e.target.closest(".acc-header");
  if (!header) return;

  const content = header.nextElementSibling;

  // close others (optional, cleaner UX)
  document.querySelectorAll(".acc-content").forEach(el => {
    if (el !== content) {
      el.style.maxHeight = null;
      el.previousElementSibling.classList.remove("active");
    }
  });

  // toggle current
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    header.classList.remove("active");
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    header.classList.add("active");
  }
});

// search-open

document.addEventListener("DOMContentLoaded", function () {

  setTimeout(() => {

    if (window.innerWidth <= 950) return;

    const searchEl = document.querySelector('.header__search details');
    const headerMain = document.querySelector('.header');

    if (!searchEl || !headerMain) {
      console.log("Element not found ❌");
      return;
    }

    new MutationObserver(() => {
      const isOpen = searchEl.hasAttribute("open");
      headerMain.classList.toggle("open-search", isOpen);
    }).observe(searchEl, {
      attributes: true,
      attributeFilter: ['open']
    });

  }, 500);

});

// search-open  


//footer reaches js

document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.cust-footer-section');
  const headerRight = document.querySelector('.nav-header-right');
  const header = document.querySelector('.header');

  if (!footer || !headerRight || !header) return;

  const handleScroll = () => {
    const footerTop = footer.getBoundingClientRect().top;
    const headerHeight = header.offsetHeight;

    if (footerTop <= headerHeight + 10) {
      headerRight.classList.add('footer-reached');
    } else {
      headerRight.classList.remove('footer-reached');
    }
  };

  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
});

//footer reaches js

// Size Guide start 

function sizeChartToggle(btn) {
  const mainProduct = btn.closest("product-info");
  const currentChart = mainProduct.querySelector(".pdp-size-chart");

  currentChart.classList.toggle("active");

  if (currentChart.classList.contains("active")) {
    currentChart.onclick = (e) => {
      if (!e.target.closest(".size-char-box-main")) {
        currentChart.classList.remove("active");
      }
    };
  }
}


// Size Guide End 

